import Link from 'next/link';
import React from 'react';

/** A component that either renders an anchor element or a span, depending on if the href is provided. The anchor
 * will be a NextJS Link element, with an anchor inside. Any class attribute that is provided will either go on the
 * span element or the anchor element
 */
export const OptionalLink: React.FC<
  Omit<React.ComponentProps<typeof Link>, 'href'> & { href?: string }
> = ({ href, children, ...props }) => {
  if (!href) {
    return <span {...props}>{children}</span>;
  }

  return (
    <Link href={href} {...props}>
      <a>{children}</a>
    </Link>
  );
};
